import {
  UpstashError,
  __spreadValues
} from "./chunk-7YUZYRJS.mjs";

// pkg/http.ts
var HttpClient = class {
  constructor(config) {
    this.baseUrl = config.baseUrl.replace(/\/$/, "");
    this.headers = __spreadValues({
      "Content-Type": "application/json"
    }, config.headers);
    this.options = config.options;
  }
  async request(req) {
    var _a;
    if (!req.path) {
      req.path = [];
    }
    const res = await fetch([this.baseUrl, ...req.path].join("/"), {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(req.body),
      backend: (_a = this.options) == null ? void 0 : _a.backend
    });
    const body = await res.json();
    if (!res.ok) {
      throw new UpstashError(body.error);
    }
    return body;
  }
};

export {
  HttpClient
};
